var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "questionnaireTableContainer layout-column",
      class: _vm.template.classes,
      attrs: { id: _vm.template.id },
    },
    [
      _c("div", { staticClass: "flex-hold" }, [
        _c("div", { staticClass: "questionnaireTableHeaderText" }, [
          _vm._v(_vm._s(_vm.template.name) + " Table"),
        ]),
        _vm.template.manageRows && !_vm.template.readOnly
          ? _c(
              "div",
              [
                _vm._l(_vm.template.manageRows, function (action) {
                  return [
                    _vm.canAdd(action.id) || _vm.canRemove(action.id)
                      ? _c(
                          "div",
                          {
                            key: action.id,
                            staticClass: "questionnaireTableActionContainer",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "questionnaireTableActionButton",
                                attrs: { disabled: !_vm.canAdd(action.id) },
                                on: {
                                  click: function ($event) {
                                    return _vm.onActionAdd(action.id)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("add"),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "questionnaireTableActionLabel" },
                              [_vm._v(" " + _vm._s(action.label) + " ")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "questionnaireTableActionButton",
                                attrs: { disabled: !_vm.canRemove(action.id) },
                                on: {
                                  click: function ($event) {
                                    return _vm.onActionRemove(action.id)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("remove"),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "flex-hold layout-row" }, [
        _c("div", { staticClass: "questionnaireTableWrapper" }, [
          _c(
            "table",
            { staticClass: "questionnaireTable" },
            [
              _vm._l(_vm.template.cells, function (row) {
                return [
                  _vm.isInFilter(row.for)
                    ? _c(
                        "tr",
                        {
                          key: row.id,
                          staticClass: "questionnaireTableRow",
                          class: row.classes,
                        },
                        [
                          _vm._l(row.cells, function (cell, cIndex) {
                            return [
                              _vm.isInFilter(cell.for)
                                ? [
                                    cell.cell
                                      ? _c(
                                          "td",
                                          {
                                            key: cIndex,
                                            staticClass:
                                              "questionnaireTableCellQuestion",
                                            class: cell.cell.classes,
                                            attrs: {
                                              rowspan: _vm.rowSpan(cell),
                                              colspan: _vm.colSpan(cell),
                                            },
                                          },
                                          [
                                            _c("table-question", {
                                              attrs: {
                                                template: cell.cell,
                                                model: _vm.model,
                                                response: _vm.response,
                                                globals: _vm.globals,
                                              },
                                              on: { change: _vm.$rbEmit },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "td",
                                          {
                                            key: cIndex,
                                            staticClass:
                                              "questionnaireTableCellLabel",
                                            class: cell.classes,
                                            style: {
                                              width: cell.width || "auto",
                                            },
                                            attrs: {
                                              rowspan: _vm.rowSpan(cell),
                                              colspan: _vm.colSpan(cell),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(cell.name) + " "
                                            ),
                                          ]
                                        ),
                                  ]
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }